import React, { Component } from 'react';
import { withRouter  } from 'react-router-dom';
import { optionsTransaction } from '../../constants/app';
import moment from 'moment';

class OtherExpendituresTable extends Component {
    totalSum() {
        return (this.props.items.reduce((acc, item) => {
            return acc + item.sum;
        }, 0)).toFixed(2)
    }

    renderThead() {
        return (
            <thead className="kt-datatable__head" style={{ backgroundColor: '#f7f7f7' }}>
                <tr className="kt-datatable__row">                    
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Время</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Операция</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Тип транзакции</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '10%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Сумма</span>
                    </th>
                    <th className="kt-datatable__cell" style={{ width: '15%', paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Пользователь</span>
                    </th>
                    <th className="kt-datatable__cell"style={{ paddingTop: '10px', paddingBottom: '10px' }}>
                        <span style={{ color: '#000' }}>Примечание</span>
                    </th>
                </tr>
            </thead>
        );
    }
    
    renderBody() {        
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.filter((el) => {
                        let check = true;
    
                        if (this.props.filters && this.props.filters.name) {
                            check = check && (el.name === this.props.filters.name.label);
                        }
    
                        if (this.props.filters && this.props.filters.typeTransaction) {
                            check = check && (el.typeTransaction === this.props.filters.typeTransaction.value);
                        }
    
                        return check;
                        })
                        .map(item => {
                        return (
                            <tr key={item.id} className="kt-datatable__row">                            
                            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                <span>
                                    {moment(item.visible_datetime).format('HH:mm DD.MM.YYYY')}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                <span>
                                    {item.name}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                <span>
                                    {optionsTransaction.find((option) => option.value === item.typeTransaction).label}
                                </span>
                            </td>                           
                            <td className="kt-datatable__cell" style={{ width: '10%' }}>
                                <span>
                                    {parseFloat(item.sum).toFixed(2)}
                                </span>
                            </td>
                            <td className="kt-datatable__cell" style={{ width: '15%' }}>
                                <span>
                                    {item.author}
                                </span>
                            </td>
                            <td className="kt-datatable__cell">
                                <span>
                                    {item.comment}
                                </span>
                            </td>
                            <td className='kt-datatable__cell' style={{ width: '40px' }}>
                                <button className='btn btn-sm btn-icon btn-icon-md btn-secondary' onClick={() => this.props.onEditArticle(item)}> 
                                    <i className='flaticon2-contract'/> 
                                </button>
                            </td>
                        </tr>
                        )
                    }) 
                }
                <tr className="kt-datatable__row" style={{ height: '40px' }}>
                </tr>
                <tr className="kt-datatable__row">                            
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                        <span>Итог</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                    </td>                           
                    <td className="kt-datatable__cell" style={{ width: '10%' }}>
                        <span>{this.totalSum()}</span>
                    </td>
                    <td className="kt-datatable__cell" style={{ width: '15%' }}>
                    </td>
                    <td className="kt-datatable__cell">
                    </td>
                </tr>
            </tbody>
        );
    }

    renderBodyMobile() {
        return (
            <tbody className="kt-datatable__body">
                {
                    this.props.items.filter((el) => {
                        let check = true;
    
                        if (this.props.filters && this.props.filters.name) {
                            check = check && (el.name === this.props.filters.name.label);
                        }
    
                        if (this.props.filters && this.props.filters.typeTransaction) {
                            check = check && (el.typeTransaction === this.props.filters.typeTransaction.value);
                        }
    
                        return check;
                        })
                        .map(item => { 
                        return (
                            <tr key={item.id} className="kt-datatable__row">
                                <div className='mobile_div_flex column padding10px'>
                                    <div className='mobile_div_flex gap0px'>
                                        <div className='mobile_div_flex' style={{ width: '50%' }}> 
                                            <span style={{ color: '#000' }}>{`Время: ${moment(item.visible_datetime).format('HH:mm DD.MM.YYYY')}`}</span>
                                        </div>
                                        <div className='mobile_div_flex gap0px' style={{ width: '50%', justifyContent: 'flex-end' }}>
                                            <button className='btn btn-sm btn-icon btn-icon-md btn-secondary' onClick={() => this.props.onEditArticle(item)}> 
                                                <i className='flaticon2-contract'/> 
                                            </button>
                                        </div>
                                    </div>
                                    <div className='mobile_div_flex gap0px'>
                                        <span style={{ color: '#000' }}>{`Операция: ${item.name}`}</span>
                                    </div>
                                    <div className='mobile_div_flex gap0px'>
                                        <span style={{ color: '#000' }}>
                                            {`Тип транзакции: ${optionsTransaction.find((option) => option.value === item.typeTransaction).label}`}
                                        </span>
                                    </div>
                                    <div className='mobile_div_flex gap0px'>
                                        <span style={{ color: '#000' }}>{`Сумма: ${parseFloat(item.sum).toFixed(2)}`}</span>
                                    </div>
                                    <div className='mobile_div_flex gap0px'>
                                        <span style={{ color: '#000' }}>{`Автор: ${item.author}`}</span>
                                    </div>
                                    <div className='mobile_div_flex gap0px'>
                                        <span style={{ color: '#000' }}>{`Примечание: ${item.comment ? item.comment : ''}`}</span>
                                    </div>                                    
                                </div>
                            </tr>
                        )
                    }) 
                }
            </tbody>
        );
    }

    render() {
        if (this.props.items.length === 0) {
            return (
                <div></div>
            );
        }

        if(window.innerWidth <= 900) 
            return (
                <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                    {this.renderBodyMobile()}
                </table>
            );

        return (
            <table className="kt-datatable__table" style={{ minHeight: '500px' }}>
                {this.renderThead()}
                {this.renderBody()}
            </table>
        );
    }
}

export default withRouter(OtherExpendituresTable);